import { render } from "./StudentEnrollmentUploadForm.vue?vue&type=template&id=86b4c1c8&ts=true"
import script from "./StudentEnrollmentUploadForm.vue?vue&type=script&lang=ts"
export * from "./StudentEnrollmentUploadForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__